// extracted by mini-css-extract-plugin
export default {"root":"IconMessages_root__9ZfKm"};